import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: "currentColor",
      style: {"fill-opacity":"18%"}
    }, null, -1),
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "6.5",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }